import { useState } from 'react';

import Metadata from '@/shared/types/metadata/index.type';

import CreateMetadataFormFields from '../types/createMetadataFormFields.type';

type Args = {
  metadata: Metadata | null;
};

const useCreateMetadataForm = ({ metadata }: Args) => {
  const [forms, setForms] = useState<
    (CreateMetadataFormFields & { id: string; panelOpen: boolean })[]
  >([]);
  const [formErrors, setFormErrors] = useState<
    Record<string, Record<string, string>>
  >({});

  const namesInUse = metadata
    ? metadata.metadata_definitions.map((definition) => definition.metadata_key)
    : [];

  const onValidateForm = () => {
    const errors: Record<string, Record<string, string>> = {};
    const usedMetadataKeys = new Set<string>();

    forms.forEach((form) => {
      const formErrors: Record<string, string> = {};

      if (!form.metadata_key) {
        formErrors.metadata_key = 'Metadata key is required';
      } else if (namesInUse.includes(form.metadata_key)) {
        formErrors.metadata_key = 'Metadata key is already in use';
      }

      if (usedMetadataKeys.has(form.metadata_key)) {
        formErrors.metadata_key = 'You cannot have duplicate metadata keys';
      } else {
        usedMetadataKeys.add(form.metadata_key);
      }

      if (!form.metatype_id) {
        formErrors.metatype_id = 'Metatype ID is required';
      }

      errors[form.id] = formErrors;
    });

    setFormErrors(errors);

    return Object.entries(errors).every(
      ([, value]) => Object.keys(value).length === 0,
    );
  };

  const onDeleteForm = (id: string) => {
    setForms((prev) => prev.filter((form) => form.id !== id));
  };

  const onAddNewForm = () => {
    const newForms = [...forms];

    newForms.map((form) => form.panelOpen && (form.panelOpen = false));
    setForms([
      ...newForms,
      {
        id: Date.now().toString(),
        panelOpen: true,
        metadata_key: '',
        metatype_id: '',
        required_level: [],
        metadata_category: '',
        description: '',
      },
    ]);
  };

  const onUpdateFormValue = (id: string, value: Record<string, unknown>) => {
    const newForms = [...forms];
    const index = newForms.findIndex((form) => form.id === id);

    newForms[index] = { ...newForms[index], ...value };
    setForms(newForms);
  };

  const onToggleAccordion = (id: string) => {
    const newForms = [...forms];

    newForms.map(
      (form) => form.id === id && (form.panelOpen = !form.panelOpen),
    );
    setForms(newForms);
  };

  return {
    forms,
    formErrors,
    onValidateForm,
    onDeleteForm,
    onAddNewForm,
    onUpdateFormValue,
    onToggleAccordion,
  };
};

export default useCreateMetadataForm;
